import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-area-square",
  "use": "foquz-icon-area-square-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-area-square\"><path d=\"M2 2h.01M10 2h.01M2 10h.01M10 10h.01M2 4.7h.01m7.99 0h.01M2 7.3h.01m7.99 0h.01m-5.305 2.705v-.01m0-7.99v-.01m2.6 8.01v-.01m0-7.99v-.01\" stroke=\"#679\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol